var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.videos),function(videoItem){return _c('div',{key:videoItem.id,staticClass:"video-item",on:{"click":function($event){return _vm.switchVideo(videoItem)}}},[(_vm.isJoin)?void 0:_c('img',{staticClass:"play-icon",attrs:{"src":require("@/assets/course/lock.png")}}),_c('div',{staticClass:"video-title"},[_c('div',{staticClass:"text",class:{
          active: videoItem.id === _vm.video.id,
         
        }},[_vm._v(" "+_vm._s(videoItem.title)+" ")])])],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }